import React from "react";

import { SelectProviderForDropzone } from "../PhotoUpload/hooks/useSelect";
import { EditPhotoUploadProvider } from "../PhotoUpload/Edit/EditPhotoUploadContext";
import { ReleasesProvider } from "../PhotoUpload/Releases/hooks/useReleases";
import { PhotoUploadDropzoneProvider } from "../PhotoUploadDropzone/usePhotoUploadDropzone";
import { AllPhotoUploadsProvider } from "./context/AllPhotoUploadsContext";

const PhotoUploadProviders = ({ children }) => {
    return (
        <AllPhotoUploadsProvider>
            <PhotoUploadDropzoneProvider>
                <ReleasesProvider>
                    <SelectProviderForDropzone>
                        <EditPhotoUploadProvider>
                            {children}
                        </EditPhotoUploadProvider>
                    </SelectProviderForDropzone>
                </ReleasesProvider>
            </PhotoUploadDropzoneProvider>
        </AllPhotoUploadsProvider>
    );
};

export default PhotoUploadProviders;
